export default __webpack_public_path__ + "static/media/vid12.240d8e78.mp4";